import { Spinner } from 'native-base';
import React from 'react';

export default function() {
    return (<Spinner color='#222'/>);
}